import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineEnvelopeAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3ZM5 6h14a1 1 0 0 1 1 1l-8 4.88L4 7a1 1 0 0 1 1-1Zm15 11a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V9.28l7.48 4.57a.9997.9997 0 0 0 1 0L20 9.28V17Z"/>
  </SvgIcon>
}

export default LineEnvelopeAltIcon
